import angular from 'angular';

angular.module('printers').factory('dgfeResult', ["$mdDialog", "$translate", "environmentInfo", "systemUtils", "util", function($mdDialog, $translate, environmentInfo, systemUtils, util) {
    dgfeResultController.$inject = ["$scope", "from", "to", "result"];
    function dgfeResultController($scope, from, to, result) {
        $scope.from = from;
        $scope.to = to;
        $scope.result = result;

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.canShare = function() {
            return environmentInfo.canShare();
        };

        $scope.share = async function() {
            const title = ($scope.from && $scope.to)
                ? `${$translate.instant('PRINTERS.DGFE.FROM')} ${$scope.from} ${$translate.instant('PRINTERS.DGFE.TO')} ${$scope.to}`
                : $translate.instant('PRINTERS.DGFE.DGFE');

            const blob = new Blob(['\ufeff', result], { type: 'text/plain' });
            const dataUrl = await util.blobToDataURL(blob);

            systemUtils.share({
                title: title,
                text: title,
                files: [`df:${title}.txt;${dataUrl}`],
            });
        };
    }

    var dgfeResult = {
        show: function(from, to, result) {
            return $mdDialog.show({
                controller: dgfeResultController,
                template: require('./dgfe-result.html'),
                locals: {
                    from: from,
                    to: to,
                    result: result
                }
            });
        }
    };

    return dgfeResult;
}]);